import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';

export const AlertDialog = (props) => {
  const { open, setOpen, title, description, callbackFunc = () => { } } = props;
  const { customAccept, customCancel, closeFun = false, disableCancel = false, disableAccept = false } = props;

  const { t } = useTranslation();
  const handleClose = () => {
    setOpen(false);
    if (closeFun) callbackFunc(false);
  };

  const handleAcept = () => {
    setOpen(false);
    callbackFunc(true);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!disableCancel &&
            <Button onClick={handleClose}>
              {customCancel || t('alertDialog:cancel')}
            </Button>
          }
          <Button onClick={handleAcept} color='primary' autoFocus disabled={disableAccept}>
            {customAccept || t('alertDialog:accept')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertDialog;
